module.exports = __webpack_public_path__ + "static/media/oot.1a9d0d57.svg";